// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "-" + {"340": "cb3077c2a2cf9e57","4": "e73c1ba66d0b006c",}[chunkId] + ".js"
}